import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import samplesSelector from 'selectors/samples/samplesSelector';
import sampleActions from 'actions/SampleActions';
import basketSelector from 'selectors/basket/basketSelector';
import { userSelector } from 'selectors/user/userSelector';
import skuUtils from 'utils/Sku';
import productSamplesActions from 'actions/ProductSamplesActions';

const { fetchSamples } = sampleActions;
const { showErrorMessage } = productSamplesActions;

const { wrapHOC } = FrameworkUtils;

const fields = createSelector(samplesSelector, basketSelector, userSelector, (samplesDetails, basket, user) => {
    const samples = basket?.items?.filter(item => skuUtils.isSample(item.sku)) || [];
    const filteredSamples = skuUtils.getFilteredSamples(samples);
    const numberOfSamplesInBasket = filteredSamples?.length;

    return {
        samplesDetails,
        numberOfSamplesInBasket,
        user
    };
});

const functions = { fetchSamples, showErrorMessage };
const withFreeSamplesProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withFreeSamplesProps
};
